import { API_DOMAIN } from './constants';

// Public links never carry the embedded query, session token or store identifier.
export function helpUrl(article = '') {
  const base = (API_DOMAIN || window.location.origin).replace(/\/$/, '');
  return `${base}/help${article ? `#${encodeURIComponent(article)}` : ''}`;
}

export const integrationHelp = {
  '/integrations/pixels': 'pixels-setup',
  '/integrations/email-marketing': 'email-sender',
  '/integrations/google-sheets': 'connect-google',
  '/integrations/google-maps': 'google-maps-key',
  '/integrations/traffic-protection': 'traffic-protection',
};
